<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2025-04-15 14:45:12
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-07-31 19:19:26
 * @FilePath: /epec-guokan-bm-v2/Users/douyunfei/Documents/epec-guokan-bidding-v2/src/modules/projectA/components/common/e-title.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="e-title-wrapper mb-[10px]">
    <div
      class="py-3.5 px-4 text-base rounded font-medium flex items-center justify-between"
      :class="[
        `text-${textSize}`,
        customClass,
        bgColor,
        `${collapsible ? 'collapsible' : ''}`,
      ]"
      @click="toggleCollapse"
    >
      <div class="flex items-center leading-none wapper-header">
        <i v-if="showIcon" :class="customIcon"></i>
        <i v-else class="inline-block w-0.5 h-3 bg-primary mr-1"></i>
        <slot>{{ title }}</slot>
      </div>

      <div
        v-if="collapsible"
        class="collapse-toggle"
        :style="{ marginBottom: isCollapsed ? '0px' : '0px' }"
      >
        <i
          :class="isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
          class="cursor-pointer"
        ></i>
        <!-- <span class="ml-1 text-sm">{{ isCollapsed ? '展开' : '收起' }}</span> -->
      </div>
    </div>

    <div
      v-show="!isCollapsed"
      class="content-area"
      :class="contentPadding ? 'pt-2' : 'pt-18'"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ETitle',
  props: {
    /**
     * 自定义的icon
     */
    customIcon: {
      type: String,
      default: '',
    },
    /**
     * The title text to display. Can be overridden by using a slot.
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Show an info icon before the title
     */
    showIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * Set the text size. Options: 'sm', 'base', 'lg'
     */
    textSize: {
      type: String,
      default: 'base',
      validator: (value) => ['sm', 'base', 'lg'].includes(value),
    },
    /**
     * Add custom CSS classes to the title container
     */
    customClass: {
      type: String,
      default: '',
    },
    /**
     * 背景色渐变色
     */
    bgColor: {
      type: String,
      default: 'e-title-bule',
    },
    /**
     * 是否可折叠
     */
    collapsible: {
      type: Boolean,
      default: false,
    },
    /**
     * 初始状态是否折叠
     */
    defaultCollapsed: {
      type: Boolean,
      default: false,
    },
    /**
     * 内容区域是否有内边距
     */
    contentPadding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCollapsed: this.defaultCollapsed,
    };
  },
  methods: {
    toggleCollapse() {
      if (!this.collapsible) return;
      this.isCollapsed = !this.isCollapsed;
      this.$emit('collapse-change', this.isCollapsed);
    },
  },
};
</script>

<style scoped>
.e-title-wrapper {
  width: 100%;
}
.wapper-header {
  color: #333;
  font-family: PingFangSC-Medium;
}

.e-title-bule {
  border-radius: 0;
  border: 1px solid var(--b-4-bddbff, #d9d9d9);
  background: #f5f5f5;
}

.e-title-gray {
  border-radius: 0;
  border: 1px solid var(--gy-5-d-9-d-9-d-9, #d9d9d9);
  background: #f5f5f5;
}

.collapse-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #606266;
  transition: all 0.3s;
}

.collapse-toggle:hover {
  color: #409eff;
}

.content-area {
  transition: all 0.3s ease;
  border: 1px solid rgba(217, 217, 217, 1);
  border-top: none;
  padding: 20px;
  background: #fff;
}

.e-title-bule {
  border-radius: 0;
  border: 1px solid var(--b-4-bddbff, #d9d9d9);
  background: #f5f5f5;
}
.flex {
  display: flex;
}
.font-medium {
  font-weight: 500;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.py-3\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.mb-\[10px\] {
  margin-bottom: 10px;
}
.collapsible {
  cursor: pointer;
}
</style>
